import React, { useState, useCallback, useMemo } from "react";
import Navbar from "@/components/layout/Navbar";
import Hero from "@/components/sections/Hero";
import Problem from "@/components/sections/Problem";
import Solution from "@/components/sections/Solution";
import Results from "@/components/sections/Results";
import HowItWorks from "@/components/sections/HowItWorks";
import UseCases from "@/components/sections/UseCases";
import ROICalculator from "@/components/sections/ROICalculator";
import Guarantee from "@/components/sections/Guarantee";
import FAQ from "@/components/sections/FAQ";
import FinalCTA from "@/components/sections/FinalCTA";
import Footer from "@/components/layout/Footer";
import DemoFormPopup from "@/components/DemoFormPopup";
import InterVilleLinks from "@/components/sections/InterVilleLinks";
import MetiersSection from "@/components/sections/MetiersSection";
import MobileLeadForm from "@/components/MobileLeadForm";
import { createContext, useContext } from "react";

// Context for demo popup
export const DemoPopupContext = createContext();

export const useDemoPopup = () => {
  const context = useContext(DemoPopupContext);
  if (!context) {
    throw new Error("useDemoPopup must be used within DemoPopupProvider");
  }
  return context;
};

export default function LandingPage({ metierOverride }) {
  const [isDemoPopupOpen, setIsDemoPopupOpen] = useState(false);

  const openDemoPopup = useCallback(() => setIsDemoPopupOpen(true), []);
  const closeDemoPopup = useCallback(() => setIsDemoPopupOpen(false), []);

  const contextValue = useMemo(
    () => ({ openDemoPopup, closeDemoPopup }),
    [openDemoPopup, closeDemoPopup]
  );

  // Extract metier slug for InterVilleLinks
  const metierSlug = metierOverride?._metierSlug || null;

  return (
    <DemoPopupContext.Provider value={contextValue}>
      <div className="min-h-screen">
        <Navbar />
        <Hero metierOverride={metierOverride} />
        <Problem metierOverride={metierOverride} />
        <Solution />
        <Results />
        <HowItWorks />
        <UseCases />
        <ROICalculator />
        <Guarantee />
        <FAQ metierOverride={metierOverride} />
        <FinalCTA />

        {/* Inter-ville links for SEO maillage interne */}
        {metierOverride && (
          <InterVilleLinks
            metierSlug={metierSlug}
            metierTitle={metierOverride.title}
            currentVille={metierOverride.ville?.slug}
          />
        )}

        {/* Métiers section on homepage only */}
        {!metierOverride && <MetiersSection />}

        <Footer />
        
        {/* Demo Form Popup */}
        <DemoFormPopup isOpen={isDemoPopupOpen} onClose={closeDemoPopup} />

        {/* Mobile sticky lead form */}
        <MobileLeadForm />
      </div>
    </DemoPopupContext.Provider>
  );
}
